<div class="order-detail">
  <div class="guest-info">
    <mat-accordion>
      <!-- [expanded]="isSubmitted && (!data.customer?.isValid || !selectedTables!.length)" -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div>
              <img src="/assets/images/icons/orders/user-circle.svg" class="mr-2" alt="">
              <span>
                {{'orders.Guest Info' | translate }}
                <span class="grey-color font-14 fontLight">({{'forms.Optional' | translate}})</span>
              </span>
            </div>

            <div class="ml-auto">
              <div class="orange-color" *ngIf="serachGuestDate?.customerPoints?.totalPoint">
                {{'Redeeming.loyalty points' | translate}}: <b>{{serachGuestDate?.customerPoints?.totalPoint}}</b>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div [formGroup]="formGroup">
          <div class="search-container">
            <div class="input-group search-control" [ngClass]="{'loading-field': searchLoading}">
              <div class="input-group-prepend">
                <button class="input-group-text" type="button" (click)="searchByText($event)">
                  <img src="./assets/images/icons/search.svg" alt="">
                </button>
              </div>
              <input type="text" class="form-control search-text"
                [(ngModel)]="searchText"
                [placeholder]="'reservations.Search for guests by phone number or name' | translate"
                (keyup)="clearAutocompleteList()"
                (keydown.enter)="searchByText($event)"
                [ngModelOptions]="{standalone: true}"
                [matAutocomplete]="auto">

              <mat-autocomplete #auto="matAutocomplete"
                (optionSelected)="guestSelected($event.option.value)">
                <mat-option class="search-guest-option" *ngFor="let option of searchDataList"
                  [value]="option">
                  {{option.fName + ' ' + option.lName}} <span class="d-ltr">({{option.phoneCode + ' ' + option.phoneNumber}})</span>
                </mat-option>
              </mat-autocomplete>

              <button mat-icon-button (click)="clearSearchUser()" type="button" *ngIf="serachGuestDate">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <!-- <p class="has-error mb-0" *ngIf="(phone.errors?.['pattern']) && !searchValid">
              {{ 'forms.Invalid' | translate }}</p> -->
          </div>
          <div class="form-container pt-3">
            <div class="row">
              <div class="col-6">
                <mat-form-field class="font-16" hideRequiredMarker>
                  <mat-label>{{"forms.First name" | translate}}</mat-label>
                  <input matInput formControlName="fName" maxlength="50"
                    [readonly]="serachGuestDate ? true : false"
                    [required]="isRequired" (ngModelChange)="fieldsChanges()">
                  <mat-error *ngIf="hasError('fName', 'required')">
                    {{ 'forms.Required' | translate }}
                  </mat-error>
                  <mat-error *ngIf="hasError('fName', 'pattern')">
                    {{ 'forms.Invalid value' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="font-16" hideRequiredMarker>
                  <mat-label>{{"forms.Last name" | translate}}</mat-label>
                  <input matInput formControlName="lName" maxlength="50"
                    [readonly]="serachGuestDate ? true : false"
                    [required]="isRequired" (ngModelChange)="fieldsChanges()">
                  <mat-error *ngIf="hasError('lName', 'required')">
                    {{ 'forms.Required' | translate }}
                  </mat-error>
                  <mat-error *ngIf="hasError('lName', 'pattern')">
                    {{ 'forms.Invalid value' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="app-phoneNumber mt-1" [class.loading-field]="countryLoading">
              <div class="input-group" [ngClass]="{'field-error': phoneHasError()}"
                (focusout)="isTouched = true">

                <div class="input-group-prepend w-70">
                    <ng-select [items]="countryList" [disabled]="serachGuestDate ? true : false"
                        formControlName="phoneflag"
                        bindValue="id" bindLabel="name"
                        (change)="flagChanged()"
                        (ngModelChange)="fieldsChanges()">
                        <ng-template ng-label-tmp let-item="item">
                          <div class="flag-selected"><img [src]="item.countryFlag" alt=""></div>
                          {{item.countryKey }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <span class="flag-list"><img [src]="item.countryFlag" alt=""></span>
                          {{item.name}}
                          <span class="grey-color">{{item.countryKey }}</span>
                        </ng-template>
                    </ng-select>
                </div>

                <input type="tel" class="form-control"
                    [placeholder]="'forms.Phone number' | translate"
                    formControlName="phoneNumber"
                    (ngModelChange)="fieldsChanges()"
                    (keydown.enter)="searchByPhoneNumber($event)"
                    appOnlynumber [required]="isRequired"
                    [disabled]="serachGuestDate ? true : false">
              </div>

              <p class="custom-error"
                *ngIf="hasError('phoneNumber', 'required')"
                [class.active]="hasError('phoneNumber', 'required')"
              >
                  {{ 'forms.Required' | translate }}
              </p>
              <p class="custom-error"
                *ngIf="hasError('phoneNumber', 'minlength') || hasError('phoneNumber', 'maxlength')"
                [class.active]="hasError('phoneNumber', 'minlength') || hasError('phoneNumber', 'maxlength')"
              >
                  {{ 'forms.Invalid value' | translate }}
              </p>
            </div>

            <!-- <app-phone-number
              [formGroup]="formGroup"
              [controlName]="'phoneNumber'"
              [disabled]="serachGuestDate ? true : false"
              [required]="isRequired"
              [isSubmitted]='isSubmitted'
              [selectedCountry]="selectedCountry"
              [loading]="searchLoading"
              [isCleared]="isCleared"
              (valueChanged)="searchByPhoneNumber($event)">
            </app-phone-number> -->


            <div class="mb-3">
              <div class="selected-table mb-3 mt-0" *ngIf="selectedTables.length">
                <label>{{'reservations.Selected table(s)' | translate}}</label>
                <div class="selected-value">
                  <ng-container *ngFor="let item of selectedTables; index as i"><ng-container *ngIf="i > 0">,
                    </ng-container>{{item.name}}</ng-container>
                </div>
              </div>
              <div class="row">
                <div class="col flex-grow-1">
                  <button mat-button class="btn-light w-100"
                    (click)="openChooseTables()">
                    {{'reservations.Choose Table' | translate}}
                  </button>
                  <p class="has-error" *ngIf="isSubmitted && !selectedTables?.length && tableRequired">
                    {{'reservations.No tables selected' | translate}}
                  </p>
                </div>
                <div class="col flex-grow-0" *ngIf="selectedTables?.length">
                  <button mat-button class="btn-grey-E" (click)="removeTables()">
                    {{'general.Clear' | translate}}
                  </button>
                </div>
              </div>
            </div>


            <button mat-button class="w-100 mb-4" color="primary"
              *ngIf="isOrdered"
              [class.loading]="changeTableLoading"
              [disabled]="changeTableLoading"
              (click)="confirmTable()">
              {{'auth.confirm' | translate}}
            </button>

          </div>
        </div>

      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
